<template>
    <div>
        <button
            @click="showModal(row.id)"
            class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
            <span class="tooltip-text">جزئیات</span>
            <i class="fas fa-eye"></i>
        </button>
        <div :id="'sub_factor_detail_' + row.id" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div :id="'data_sheet_' + row.id" class="modal-body">
                        <div class="modal-header">
                            <h4 class="modal-title text-white">جزئیات تراکنش</h4>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="my-2">
                                <p>جزئیات فرم فاکتور</p>
                                <div v-for="(field, index) in row.fields" :key="index" class="d-flex justify-content-between">
                                    <p>{{ index }}</p>
                                    <p>{{ field }}</p>
                                </div>
                                <button class="btn btn-primary text-center mx-auto">
                                    <router-link
                                        :to="`/invoice/${$route.params.hashid}/sub-factor/${row.id}` + (row.success_payment_details.id !== false ? `?payment=${row.success_payment_details.id}` : '')"
                                        class="router-link-white"
                                    >
                                        لینک فاکتور
                                    </router-link>
                                </button>
                            </div>
                            <div class="my-2 mt-5">
                                <p>جزئیات محصولات</p>

                                <table class="table w-100 text-dark font-weight-bold mx-auto">
                                    <thead class="text-center">
                                    <tr>
                                        <th class="text-white">آیتم</th>
                                        <th class="text-white">تعداد</th>
                                        <th class="text-white">قیمت محصول</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr
                                        v-for="(item, idx) in row.items"
                                        :key="(item, idx)"
                                    >
                                        <td class="text-white">{{ item.title }}</td>
                                        <td class="text-white">{{ item.number }}</td>
                                        <td class="text-white">{{ item.final_amount.toLocaleString() + " ریال" }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import $ from 'jquery'

export default Vue.extend({
    name: 'FactorTransactionActionColumn',
    props: {
      row: {
        required: true,
      },
      index: {
        required: true,
      },
      datatable: {
        required: true,
      }
    },
    methods: {
        showModal(id) {
            $(`#sub_factor_detail_${id}`).modal('show')
        },
    }
});
</script>

<style scoped></style>
